export const typo = {
    fontWeight: '500', 
    mb: '8px'
}
export const box = { 
    width: "100%" 
}
export const textF = (theme) => ({
    width: '100%', 
    backgroundColor: theme.palette.primary.inputBackground
});